export const Gifs = {
  andyBigFlex: new URL("../UserAssets/gifs/andy-big-flex.gif", import.meta.url).href,
  andyBigFlex1: new URL("../UserAssets/gifs/andy-big-flex1.gif", import.meta.url).href,
  andyBigFlex2: new URL("../UserAssets/gifs/andy-big-flex2.gif", import.meta.url).href,
  andyConfetti: new URL("../UserAssets/gifs/andy-confetti.gif", import.meta.url).href,
  andyCop: new URL("../UserAssets/gifs/andy-cop.gif", import.meta.url).href,
  andyWalking: new URL("../UserAssets/gifs/andy-walking.gif", import.meta.url).href,
  andyBio: new URL("../UserAssets/gifs/AndyBio.gif", import.meta.url).href,
  spinner: new URL("../UserAssets/gifs/spinner.gif", import.meta.url).href,
  document: new URL("../UserAssets/gifs/document.gif", import.meta.url).href,
  documentAnimation: new URL("../UserAssets/gifs/documentanimation.gif", import.meta.url).href,
  zoomFinger: new URL("../UserAssets/gifs/zoom_finger.gif", import.meta.url).href,
} as const;
